import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
import { z } from "zod";
import { ensureElementVisible } from "@/lib/route-guards";

const ExpiryBatchesPage = lazy(() =>
	import("@/features/reports/expiry-batches-page").then((m) => ({ default: m.ExpiryBatchesPage })),
);

// Wszystkie filtry deep-linkowalne — raport wysyla sie kolegom linkiem,
// a nie zrzutem ekranu.
const searchSchema = z.object({
	scope: z.string().optional(),
	datwzFrom: z.string().optional(),
	datwzTo: z.string().optional(),
	datzkFrom: z.string().optional(),
	datzkTo: z.string().optional(),
	sortBy: z.string().optional(),
	sortDir: z.enum(["asc", "desc"]).optional(),
	// Filtry naglowkowe DataTable — generyczny JSON [{id, value}].
	columnFilters: z.string().optional(),
});

export type DatyWaznosciSearch = z.infer<typeof searchSchema>;

export const Route = createFileRoute("/_auth/raporty/daty-waznosci")({
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.raporty.daty-waznosci",
			location.pathname,
		);
	},
	component: ExpiryBatchesPage,
	validateSearch: (search: Record<string, unknown>): DatyWaznosciSearch =>
		searchSchema.parse(search),
});
